"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomQiQuanMainTab2 = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
require("./index.less");
var tabsconfig_1 = require("./tabsconfig");
/**
 * 自定义期权二级tab
 * @param props
 * @returns
 */
function CustomQiQuanMainTab2(props) {
    var _a, _b;
    var _c = (0, react_1.useState)(0), selectindex = _c[0], SetSelectIndex = _c[1];
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash;
    // let navkey = hash.substring(0, findIndex(hash, '_', 1))
    var navkey = hash.substring(0, hash.lastIndexOf("_"));
    var isMatch = ((_a = tabsconfig_1.maintabconfig[navkey]) === null || _a === void 0 ? void 0 : _a.matchs.indexOf(hash)) > -1;
    if (!isMatch)
        return react_1.default.createElement(react_1.default.Fragment, null);
    var itemlist = ((_b = tabsconfig_1.maintabconfig[navkey]) === null || _b === void 0 ? void 0 : _b.navbar) || [];
    var style = {};
    if (props.mt != undefined && props.mt > 0) {
        style.marginTop = props.mt + 'px';
    }
    if (itemlist.length < 1)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "qq_maintab", style: style },
        react_1.default.createElement("ul", { className: "scf" }, itemlist.map(function (v, index) {
            return react_1.default.createElement(react_1.default.Fragment, { key: index },
                react_1.default.createElement("li", { className: v.path == hash ? 'active' : '', onClick: function (e) { e.preventDefault(); SetSelectIndex(index); } }, !v.path ? react_1.default.createElement("span", null, v.title) : react_1.default.createElement(react_router_dom_1.Link, { to: v.path }, v.title)));
        }))));
}
exports.CustomQiQuanMainTab2 = CustomQiQuanMainTab2;
function findIndex(str, cha, num) {
    var x = str.indexOf(cha);
    for (var i = 0; i < num; i++) {
        x = str.indexOf(cha, x + 1);
    }
    return x;
}
